import React from "react";
import { Grid, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import NoButtonsInfoDialog from "components/v3/sharedComponents/modals/NoButtonsInfoDialog";
import { COLORS } from "components/v3/Theme/colors";
import CurlyArrow from "assets/images/CurlyArrow.svg";
import CheckYourEmail from "assets/images/Check-your-email.svg";
import EmailClip from "assets/images/EmailClip.png";

interface RegistrationHelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HelpModal: React.FC<RegistrationHelpModalProps> = ({
  isOpen,
  onClose
}) => {
  const theme = useTheme();
  const isExtraNarrow = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <NoButtonsInfoDialog
      isOpen={isOpen}
      onClose={onClose}
      width={{
        xs: 11,
        sm: 10,
        md: 9,
        lg: 6
      }}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: "100%",
          width: "100%",
          textAlign: "center"
        }}
      >
        <Grid item container xs={12} justifyContent="center">
          <Grid
            item
            xs={11}
            sx={{
              marginBottom: "40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <Grid item sx={{ marginBottom: "15px", width: "100%" }}>
              <Typography
                variant={`${
                  isExtraNarrow ? "body_strong_lg" : "body_strong_xl"
                }`}
              >
                Need help? We're here!
              </Typography>
            </Grid>
            <Grid item sx={{ marginBottom: "20px", width: "100%" }}>
              <Typography variant="body">
                Having trouble with your code or don't have one?
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  maxWidth: "650px",
                  position: "relative",
                  margin: "0 auto"
                }}
              >
                <Box
                  component="img"
                  src={EmailClip}
                  mb="10px"
                  mt="30px"
                  sx={{
                    position: "relative",
                    top: 0,
                    width: "100%",
                    maxWidth: "650px"
                  }}
                />
                <Box
                  component="img"
                  src={CurlyArrow}
                  sx={{
                    width: "106px",
                    height: "71px",
                    position: "absolute",
                    right: { xs: "36px", sm: "108px" },
                    top: { xs: "30px", sm: "54px" }
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    width: "150px",
                    background:
                      "linear-gradient(90deg, #60C2A5 0%, #2D5DA9 100%)",
                    borderRadius: "24px",
                    padding: "8px 8px",
                    right: "-29px",
                    top: { xs: "5px", sm: "22px" }
                  }}
                >
                  <Box
                    component="img"
                    src={CheckYourEmail}
                    sx={{
                      height: "16px",
                      top: "4px",
                      left: "1px",
                      position: "relative"
                    }}
                  />
                </Box>
              </Box>
              <Typography variant="body_xs_dark_gray" mb="40px">
                Your access code was sent to the email address provided by your
                employer, please check your work and personal emails including
                your spam. These emails are coming from noreply@genomiclife.com.
              </Typography>
              <Typography variant="body" mb="30px">
                If you can't find your access code or are still having trouble,
                send us an email at{" "}
                <strong>
                  <a href="mailto:navigation@genomiclife.com">
                    navigation@genomiclife.com
                  </a>
                </strong>
              </Typography>
              <Typography variant="body_xs_dark_gray" mb="20px">
                <i>
                  To ensure your privacy & security we may ask the same
                  information you just gave us.
                </i>
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  borderBottom: `1px solid ${COLORS.GRAY}`,
                  my: 2
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                <Typography
                  sx={{
                    color: COLORS.SECONDARY,
                    marginTop: "10px"
                  }}
                >
                  Have your access code?{" "}
                  <Box
                    sx={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      display: "inline"
                    }}
                    onClick={() => {
                      onClose();
                    }}
                  >
                    <strong>Try again</strong>
                  </Box>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </NoButtonsInfoDialog>
  );
};

export default HelpModal;
